const _excluded = ["isAuto", "onLoad", "onRetry"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useInView } from 'react-intersection-observer';
const useLoadMoreData = _ref => {
  let {
      isAuto,
      onLoad: onLoadProp,
      onRetry: onRetryProp
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [internalIsLoading, setInternalIsLoading] = React.useState(false);
  const isLoading = typeof props.isLoading === 'boolean' ? props.isLoading : internalIsLoading;
  const [internalHasError, setInternalHasError] = React.useState(false);
  const hasError = typeof props.hasError === 'boolean' ? props.hasError : internalHasError;
  const [inViewRef, inView] = useInView();
  const onLoad = React.useCallback(() => {
    setInternalIsLoading(true);
    setInternalHasError(false);
    return onLoadProp().catch(() => setInternalHasError(true)).finally(() => setInternalIsLoading(false));
  }, [onLoadProp, setInternalIsLoading, setInternalHasError]);
  const onRetry = React.useCallback(() => {
    setInternalIsLoading(true);
    setInternalHasError(false);
    const caller = onRetryProp || onLoadProp;
    return caller().catch(() => setInternalHasError(true)).finally(() => setInternalIsLoading(false));
  }, [onRetryProp, onLoadProp, setInternalIsLoading, setInternalHasError]);
  React.useEffect(() => {
    if (inView && isAuto) {
      (async function () {
        await onLoad();
      })();
    }
  }, [inView, isAuto, onLoad]);
  return {
    inViewRef,
    isLoading,
    hasError,
    onLoad,
    onRetry
  };
};
export default useLoadMoreData;
//# sourceMappingURL=useLoadMoreData.js.map